import { render, staticRenderFns } from "./Submodel.vue?vue&type=template&id=152dd1eb&scoped=true&"
import script from "./Submodel.vue?vue&type=script&lang=js&"
export * from "./Submodel.vue?vue&type=script&lang=js&"
import style0 from "./Submodel.vue?vue&type=style&index=0&id=152dd1eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152dd1eb",
  null
  
)

export default component.exports